import { ActionFunction } from "react-router-dom";
import { isAxiosError } from "axios";
import { backendApi } from "../../api";

export const action: ActionFunction = async ({ request }) => {
  const data = Object.fromEntries(await request.formData());
  try {
    const response = await backendApi({
      method: "POST",
      url: "/users/create",
      data,
    });
    return response;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 422) {
      return error.response.data;
    }
    throw error;
  }
};
